export default __webpack_public_path__ + "static/media/top_10_mental_health.f8747173.png";